import { NgModule, ModuleWithProviders } from '@angular/core';
import { JwtInterceptor } from '../globaldependencies/intercepter/jwt.interceptor';
import { SidenavUiService } from './services/sidenav-ui.service';
import { RealTimeSignalRHub } from './services/signalr-hub.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RealTimeSignalRCoreHub } from './services/signalr-core-hub.service';

@NgModule({})
export class SnovaSharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SnovaSharedModule,
      providers: [RealTimeSignalRHub,RealTimeSignalRCoreHub, SidenavUiService, { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }]
    };
  }
}
